"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "siracusa": {
    "0d92c023": [{
      "hkey": "7a82fb29",
      "slug": "borgata-santa-lucia",
      "name": "Borgata-Santa Lucia",
      "primary": true,
      "skipSearch": false
    }],
    "borgata": [{
      "hkey": "7a82fb29",
      "slug": "borgata-santa-lucia",
      "name": "Borgata-Santa Lucia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "04c44a49": [{
      "hkey": "33f3a558",
      "slug": "cadorna-gelone",
      "name": "Cadorna-Gelone",
      "primary": true,
      "skipSearch": false
    }],
    "gelone": [{
      "hkey": "33f3a558",
      "slug": "cadorna-gelone",
      "name": "Cadorna-Gelone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54de79fc": [{
      "hkey": "90f882e8",
      "slug": "grottasanta-tunisi",
      "name": "Grottasanta-Tunisi",
      "primary": true,
      "skipSearch": false
    }],
    "grottasanta": [{
      "hkey": "90f882e8",
      "slug": "grottasanta-tunisi",
      "name": "Grottasanta-Tunisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c18e53a8": [{
      "hkey": "4ee1df8b",
      "slug": "neapolis",
      "name": "Neapolis",
      "primary": true,
      "skipSearch": false
    }],
    "grotticelle": [{
      "hkey": "4ee1df8b",
      "slug": "neapolis",
      "name": "Neapolis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "siracusa"
    }],
    "b6b9dac4": [{
      "hkey": "33f3a558",
      "slug": "cadorna-gelone",
      "name": "Cadorna-Gelone",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "33f3a558",
      "slug": "cadorna-gelone",
      "name": "Cadorna-Gelone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "siracusa"
    }],
    "cd0e8c21": [{
      "hkey": "e2c3d0f3",
      "slug": "scala-greca-tiche",
      "name": "Scala Greca-Tiche",
      "primary": true,
      "skipSearch": false
    }],
    "scala-greca": [{
      "hkey": "e2c3d0f3",
      "slug": "scala-greca-tiche",
      "name": "Scala Greca-Tiche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;